module.exports = __webpack_public_path__ + "static/media/ico_simulation_lip_plumper.a3ef77e3.png";